import React from "react";
import { connect } from "react-redux";
import withRouter from "../utils/withrouter";
import { getShopOrder } from '../../redux/slice/orderSlice'


class Order extends React.Component {

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      isOrderSubmittedToCustomer: false
    }
  }

  componentDidMount = () => {
    const { orderReferenceId } = this.props;
    this.props.getShopOrder({ orderReferenceId: orderReferenceId });
  }

  componentDidUpdate = () => {
    const { order } = this.props;

    // After fetching order, submit the form to the Customer
    if (order.isFetchOrderSuccess && !this.state.isOrderSubmittedToCustomer) {
      if (this.formRef.current) {
        this.formRef.current.submit();
        this.setState({ isOrderSubmittedToCustomer: true });
      }
    }

  }

  loading = (isLoading) => {
    if (isLoading) {
      return (<p>Fetching the Order...</p>)
    } else {
      return (<></>)
    }
  }

  render = () => {
    const { order } = this.props;

    // Check for fetch success and if data is available
    if (order.isFetchOrderLoading) {
      return <div>{this.loading(true)}</div>;
    }

    if (order.isFetchOrderSuccess) {
      const { returnUrl, content } = order.fetchOrderData;

      // Define the PunchoutForm component
      const PunchoutForm = React.forwardRef(({ action, content }, ref) => (
        <form
          ref={ref}
          action={action}
          method="POST"
          target="_top"
          name="punchoutSend"
        >
          <input
            type="hidden"
            name="cXML-urlencoded"
            value={content}
            id="cXML-urlencoded"
          />
        </form>
      ));

      return (
        <div>
          <p>Punchout Web Order</p>
          <PunchoutForm ref={this.formRef} action={returnUrl} content={content} />
        </div>
      );
    }


    return <div>Something went wrong. Please try again later.</div>;
  };
};

const mapStateToProps = (state) => ({
  app: state.app,
  order: state.order
});

const mapDispatchToProps = {
  getShopOrder
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Order));